import { render, staticRenderFns } from "./CentroSubTab.vue?vue&type=template&id=b435cf0c&"
import script from "./CentroSubTab.vue?vue&type=script&lang=js&"
export * from "./CentroSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports